import { flexSpace, flexStart, ml, mr, npx, px, py } from '@/layout/styles/classes';
import { ReactComponent as StarIcon } from '@a/icons/star.svg';
import styled from '@emotion/styled';

const Section = styled.section`
    ${py};
    ${px};

    > .tagline {
        margin: 0;
        text-align: center;
    }

    > h2 {
        margin: 12px 0 24px;
        text-align: center;
        color: ${({ theme }) => theme.colors.blue7};
        text-transform: capitalize;
    }

    @media (min-width: 1280px) {
        > h2 {
            margin-bottom: 48px;
        }
    }
`;

const Cards = styled.div`
    ${npx};
    display: flex;
    align-items: flex-start;
    overflow-x: auto;
    gap: 16px;

    > div {
        :first-of-type {
            ${ml};
        }

        :nth-of-type(2) {
            ${flexStart};
        }

        :last-of-type {
            ${mr};
        }
    }

    @media (min-width: 1280px) {
        overflow-x: unset;
        align-items: center;
        justify-content: center;
        padding-left: 64px;
        padding-right: 64px;

        > div {
            :first-of-type,
            :last-of-type {
                margin: 0 !important;
            }

            :nth-of-type(2) {
                flex-direction: column;
                gap: 16px;
            }
        }
    }
`;

const Card = styled.div`
    background-color: ${({ theme }) => theme.colors.blue1};
    border-radius: 16px;
    padding: 24px 16px;
    width: 424px;
    flex-shrink: 0;

    > div {
        ${flexSpace};
        margin-bottom: 24px;

        > p {
            color: ${({ theme }) => theme.colors.blue8};
            margin: 0 auto 0 0;
            font-weight: 600;
            text-transform: capitalize;
            font-size: 1.25rem;
        }

        > svg {
            :not(:last-of-type) {
                margin-right: 2px;
            }
        }
    }

    > p {
        color: ${({ theme }) => theme.colors.gray5};
        margin: 0;
        font-size: 1rem;
    }

    @media (min-width: 1280px) {
        flex-shrink: unset;
    }
`;

export const Testimonials = () => {
    return (
        <Section>
            <p className="tagline">Testimonials</p>
            <h2>Stories from satisfied customers</h2>
            <Cards>
                <Card>
                    <div>
                        <p>lisa collins-hill</p>
                        <StarIcon />
                        <StarIcon />
                        <StarIcon />
                        <StarIcon />
                        <StarIcon />
                    </div>
                    <p>
                        I am 61 yrs old & have been using Smart A-Z Minerals for a year & half now,
                        I start out taking the individual minerals the switch to the EZ 8 when it
                        came out. I have also been giving EZ 8 to my 3 yr old granddaughter.
                    </p>
                </Card>
                <div>
                    <Card>
                        <div>
                            <p>Ryan McQuillan</p>
                            <StarIcon />
                            <StarIcon />
                            <StarIcon />
                            <StarIcon />
                            <StarIcon />
                        </div>
                        <p>
                            I would give these a 100 Stars. They have Changed my life! Minerals are
                            the key to Vitality I am a true believer. I order the Variety pack and I
                            added silver this time. Thank you so much I cant express how grateful I
                            am!
                        </p>
                    </Card>
                    <Card>
                        <div>
                            <p>Courtney Blevins</p>
                            <StarIcon />
                            <StarIcon />
                            <StarIcon />
                            <StarIcon />
                            <StarIcon />
                        </div>
                        <p>
                            The EZ8 has helped me so much and I hope other people reading this will
                            give it a shot! It’s worth it! Life is supposed to be enjoyed… and I got
                            my joy back with this product! (PS— the customer service is amazing)
                        </p>
                    </Card>
                </div>
                <Card>
                    <div>
                        <p>amber o’ daniel</p>
                        <StarIcon />
                        <StarIcon />
                        <StarIcon />
                        <StarIcon />
                        <StarIcon />
                    </div>
                    <p>
                        I absolutely love this company! They care more about you as a customer and
                        making sure you are getting what you need instead of convincing you to
                        purchase things you don’t need. My whole family uses their minerals...
                    </p>
                </Card>
            </Cards>
        </Section>
    );
};
